import {PageLink} from '../../_metronic/layout/core'
import Navigation from '../../components/Navigation/Navigation'
import CostAnalysisReport from './layouts/CostAnalysisReport'

const PriceListBreadCrumbs: Array<PageLink> = [
  {
    title: 'Products',
    path: '/products/all-products',
    isSeparator: false,
    isActive: false,
  },
]

const ProductCost = () => {
  return (
    <Navigation
      baseUrl='/products/price-cost'
      breadcrumbs={PriceListBreadCrumbs}
      defaultKey='cost-analysis-report'
      searchParams={{id: ``}}
      viewSingleComponent={true}
      navigationData={[
        {
          key: 'cost-analysis-report',
          label: 'Cost Analysis Report',
          component: <CostAnalysisReport />,
        },
      ]}
    />
  )
}

export default ProductCost
